/**
 * Utility functions for membership status checks
 */

interface ContactData {
  acepMemberStatus?: number;
  sempaMemberStatus?: number;
  acepid?: string;
  isABEMCertified?: boolean | null;
}

/**
 * Check if user is an ACEP member
 * Member statuses: 1, 2, 5, 6
 */
export const isMember = (contactData?: ContactData): boolean => {
  return contactData?.acepMemberStatus === 1 || 
         contactData?.acepMemberStatus === 2 ||
         contactData?.acepMemberStatus === 5 ||
         contactData?.acepMemberStatus === 6;
};

/**
 * Check if user is a non-member
 * Non-member statuses: 0 (excluding SEMPA status 15), 3, 4, 7
 */
export const isNonMember = (contactData?: ContactData): boolean => {
  return !!(contactData?.acepid && 
    ((contactData?.acepMemberStatus === 0 && contactData?.sempaMemberStatus !== 15) ||
     contactData?.acepMemberStatus === 3 ||
     contactData?.acepMemberStatus === 4 ||
     contactData?.acepMemberStatus === 7));
};

/**
 * Check if user is ABEM certified
 */
export const isABEMCertified = (contactData?: ContactData): boolean => {
  return contactData?.isABEMCertified === true;
};

/**
 * Check if user should show physician toggle
 * Only non-members who are NOT ABEM certified should see the toggle
 */
export const shouldShowPhysicianToggle = (contactData?: ContactData): boolean => {
  // If user is a MEMBER → NO toggle (regardless of ABEM status)
  if (isMember(contactData)) {
    return false;
  }

  // Must be non-member AND non-ABEM to show toggle
  return isNonMember(contactData) && !isABEMCertified(contactData);
};

/**
 * Check if user needs professional status attestation
 * Members and ABEM certified users NEVER need to attest
 */
export const needsProfessionalStatusAttestation = (contactData?: ContactData): boolean => {
  // If user is a MEMBER → NO popup (regardless of ABEM status)
  if (isMember(contactData)) {
    return false;
  }

  // ABEM certified users don't need attestation
  if (isABEMCertified(contactData)) {
    return false;
  }

  // Only non-members who are not ABEM certified need attestation
  return isNonMember(contactData);
};